import loadable from "@loadable/component";
import React from "react";

const OverviewComponent = loadable(
  () => import("../components/Overview") as unknown as React.ReactElement
);
const Support = () => {
  return <OverviewComponent />;
};

export default Support;
